import {
    CONTACT__DATA
} from '../actions/contactAction'

export function contactReducer(state = {
    info: 'default' 
}, action){    
    switch(action.type){ 
        case CONTACT__DATA: 
            return Object.assign({}, state, {
                info: action.data
            })        
             
        default: 
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/contactReducer.js